import React from 'react';

import {convertLocationParamsToFetchParams, useQuizzes} from 'app/quizzes/api';
import {QuizzesFetchParamsType} from 'app/quizzes/types';
import {useAddQuizzesToTeam} from 'app/teams/api';

import {AddNewTeamDocButton} from '../components/AddNewTeamDocButton';

import type {OverlayPlacementType} from 'app/general/overlays';
import type {QuizSerializedType, TeamSerializedType} from 'sweet-types';

type Props = {
  team: TeamSerializedType;
  buttonClass?: string;
  placement?: OverlayPlacementType;
};

export const AddNewTeamQuizButton = ({team, buttonClass, placement}: Props) => {
  const [addToTeam] = useAddQuizzesToTeam();

  return (
    <AddNewTeamDocButton<QuizSerializedType, QuizzesFetchParamsType>
      team={team}
      buttonClass={buttonClass}
      placement={placement}
      contentType="quiz"
      addAction={addToTeam}
      useDataHook={useQuizzes}
      paramsConverter={convertLocationParamsToFetchParams}
    />
  );
};
